// Cloudinary Upload Service
// Direct browser-to-Cloudinary upload (no backend needed)

const CLOUD_NAME = 'dytauqnma'
const API_KEY = '139523852912251'
const API_SECRET = 'q3mNHNWSHD9hTQluAGcdyHeRB1M'

const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`

// Generate SHA-1 signature for signed uploads
async function generateSignature(params: Record<string, string>): Promise<string> {
    const sorted = Object.keys(params).sort().map(k => `${k}=${params[k]}`).join('&')
    const toSign = sorted + API_SECRET
    const encoder = new TextEncoder()
    const data = encoder.encode(toSign)
    const hashBuffer = await crypto.subtle.digest('SHA-1', data)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
}

// Upload a product image to Cloudinary
export async function uploadProductImage(file: File, productCode: string): Promise<string> {
    const timestamp = Math.floor(Date.now() / 1000).toString()
    const folder = 'pos/products'
    const publicId = `${folder}/${productCode}_${timestamp}`

    const params: Record<string, string> = {
        folder,
        public_id: publicId,
        timestamp,
    }

    const signature = await generateSignature(params)

    const formData = new FormData()
    formData.append('file', file)
    formData.append('api_key', API_KEY)
    formData.append('timestamp', timestamp)
    formData.append('signature', signature)
    formData.append('folder', folder)
    formData.append('public_id', publicId)

    const res = await fetch(UPLOAD_URL, { method: 'POST', body: formData })
    if (!res.ok) {
        const err = await res.text()
        throw new Error(`Cloudinary upload failed: ${err}`)
    }

    const data = await res.json()
    return data.secure_url as string
}

// Upload an invoice image (from blob) to Cloudinary
export async function uploadInvoiceImage(blob: Blob, invoiceNumber: string): Promise<string> {
    const timestamp = Math.floor(Date.now() / 1000).toString()
    const folder = 'pos/invoices'
    const publicId = `${folder}/INV_${invoiceNumber}_${timestamp}`

    const params: Record<string, string> = {
        folder,
        public_id: publicId,
        timestamp,
    }

    const signature = await generateSignature(params)

    const formData = new FormData()
    formData.append('file', blob)
    formData.append('api_key', API_KEY)
    formData.append('timestamp', timestamp)
    formData.append('signature', signature)
    formData.append('folder', folder)
    formData.append('public_id', publicId)

    const res = await fetch(UPLOAD_URL, { method: 'POST', body: formData })
    if (!res.ok) {
        const err = await res.text()
        throw new Error(`Invoice upload failed: ${err}`)
    }

    const data = await res.json()
    return data.secure_url as string
}
